import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineArrowUpRightIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M17.9258 6.62a1.0002 1.0002 0 0 0-.54-.54.9998.9998 0 0 0-.38-.08h-10a1 1 0 0 0 0 2h7.59l-8.3 8.29A1.001 1.001 0 0 0 6 17a1.0003 1.0003 0 0 0 .2958.71 1.001 1.001 0 0 0 .71.2958.9994.9994 0 0 0 .71-.2958l8.29-8.3V17a1.0001 1.0001 0 0 0 2 0V7a1.0011 1.0011 0 0 0-.08-.38Z"/>
  </SvgIcon>
}

export default LineArrowUpRightIcon
